<template>
<div>

    <div class="row">
        <div class="list-description col-md-5">
            Select a Location
        </div>

        <div class="lzSearchContainer col-md-7">
            <div class="lzSearchBar" :class="{isTpg:isTpg}">
                <input type="search"
                   v-model="searchTerm"
                   class="lzSearchInput"
                   placeholder="Search"
                   id="searchInput">
            </div>
        </div>
    </div>

    <div class="workspace-content-list" :class="{isTpg:isTpg}">

        <div class="border-top zone-picker-row" :class="{isTpg:isTpg}"
             v-for="locationZone in filteredLocationZones"
             :key="locationZone.location_zone_id">
             <div v-if="locationZone.location_zone_id !== '17171'">
            <router-link class="selectLZ" :class="{isTpg:isTpg}" :to="{ path: '/'+ controller + '/' + locationZone.location_zone_id}">
                {{ locationZone.location_name }} - {{ locationZone.location_zone_name }}
            </router-link>
            </div>
        </div>
        <div class="empty" v-if="locationZones == null || locationZones.length < 1">
        -
        </div>
    </div>

</div>
</template>

<script>
export default {
  data() {
    return {
      locationZones: null,
      controller: null,
      filteredLocationZones: '',
      searchTerm: '',
    };
  },
  props: ['is-tpg'],
  mounted() {
    // this.getLocationZones();
    this.setController();
    this.setCursor();

    this.getLocationZones();
  },
  methods: {
    setController() {
      const { path } = this.$route;
      const split = path.split('/');
      if (split[1]) {
        this.controller = split[1];
      } else {
        this.controller = '';
      }
    },
    getLocationZones() {
      const self = this;
      this.$http.get('/location_zone').then(function (response) {
        const { locations } = response.data;
        const { location_zones } = response.data;

        self.locationZones = self.matchLocationsAndZones(locations, location_zones);
        self.filteredLocationZones = self.locationZones;

        // If only one zone, forward to main
        if (self.locationZones.length < 2) {
          self.$router.push(`${this.controller}/${self.locationZones[0].location_zone_id}`);
        }
      });
    },
    matchLocationsAndZones(locations, location_zones) {
      const matchedLocationsAndZones = [];

      for (let i = 0; i < location_zones.length; i++) {
        const { location_id } = location_zones[i];
        const location_name = this.getLocationNameFromId(locations, location_id);
        const location_zone_name = location_zones[i].name;
        const location_zone_id = location_zones[i].id;

        const location_zone = {
          location_name,
          location_id,
          location_zone_name,
          location_zone_id,
        };

        matchedLocationsAndZones.push(location_zone);
      }

      return matchedLocationsAndZones;
    },
    getLocationNameFromId(locations, location_id) {
      let location_name = '';
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].id == location_id) {
          location_name = locations[i].name;
        }
      }
      return location_name;
    },
    searchLocationZones() {
      const matchedObjects = [];
      for (let i = 0; i < this.sortedLocationZones.length; i++) {
        if (this.sortedLocationZones[i].location_name.toLowerCase().includes(this.searchTerm.toLowerCase()) || this.sortedLocationZones[i].location_zone_name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
          matchedObjects.push(this.sortedLocationZones[i]);
        }
      }

      return matchedObjects;
    },
    setCursor() {
      document.getElementById('searchInput').focus();
      document.getElementById('searchInput').select();
    },
  },
  computed: {
    sortedLocationZones() {
      if (this.locationZones && this.locationZones.length > 0) {
        return sortByKey(this.locationZones, 'location_name');
      }

      return false;
    },
  },
  watch: {
    searchTerm() {
      // If search empty, show entire list
      if (this.searchTerm.length < 1) {
        this.filteredLocationZones = this.sortedLocationZones;
        return;
      }

      this.filteredLocationZones = this.searchLocationZones();
    },
    $allLocationZones() {
      console.log(JSON.stringify(this.locationZones));
      this.filteredLocationZones = this.$allLocationZones;
    },
  },
};

function sortByKey(array, key) {
  return array.sort((a, b) => {
    const x = a[key]; const y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}
</script>
<style scoped>

.selectLZ:hover {
    color:yellow;
}
.selectLZ.isTpg:hover {
    color:#00c996;
}
.list-description {
  font-size:16px;
  font-weight: bold;
  margin-left:-15px;
}
.lzSearchContainer {
    /*float:right;*/
}
.lzPlayerSearchContainer {
    width:100%;
    clear:both;
    padding-bottom: 20px;
}
.lzSearchBar {
    float:right;
    width:300px;
    margin-right:-15px;
}
.lzSearchBar input[type="search"] {
    float:right;
  background-color: rgba(27, 27, 27, 0.5);
  border-radius: 5px;
  border:3px;
  width:250px;
  font-weight: normal;
  height:24px;
  color:white;
  padding:0 0 0 1px;
  padding-left:2px;
  border:1px solid transparent;
}
.lzSearchBar.isTpg input[type="search"] {
    background-color: rgba(255, 255, 255, 1);
    border:1px solid #ccc;
    color:black;
    height:30px;
}
@media (max-width: 1000px) {
  .lzSearchBar {
    float:left;
  }
  .lzSearchBar input[type="search"] {
    float:left;
    padding-left:0px;
    margin-left:-15px;
  }
  .lzPlayerSearchContainer {
    width:100%;
  }
}
</style>
